export default __webpack_public_path__ + "fonts/TiredLandlords-White.svg";